import { Space, Typography } from 'antd';

export function SpParagraph({ title = '', children = null, layout = 'horizontal', size = 'medium', flat = false }) {
  const fontSize = () => {
    switch (size) {
      case 'medium':
        return 14;

      case 'small':
        return 12;

      default:
        return 11;
    }
  };

  const ContainerProvide = ({ children }) => {
    if (flat) {
      return <p style={{ marginBottom: 0 }}>{children}</p>;
    } else {
      return <Space direction={layout}>{children}</Space>;
    }
  };

  return (
    <ContainerProvide>
      <Typography.Text strong style={{ fontSize: fontSize() }}>
        {title} {layout === 'horizontal' ? ':' : ''}
      </Typography.Text>
      <Typography.Text style={{ fontSize: fontSize(), fontWeight: 'lighter', marginLeft: flat ? 3 : 0 }}>
        {children}
      </Typography.Text>
    </ContainerProvide>
  );
}
